import _objectSpread from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "D:\\kavya_first_project\\aerc\\AERC_SRC_29-2-2023\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import camelize from 'dom-helpers/camelize';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var pascalCase = function pascalCase(str) {
  return str[0].toUpperCase() + camelize(str).slice(1);
};
// TODO: emstricten & fix the typing here! `createWithBsPrefix<TElementType>...`
export default function createWithBsPrefix(prefix) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$displayName = _ref.displayName,
    displayName = _ref$displayName === void 0 ? pascalCase(prefix) : _ref$displayName,
    Component = _ref.Component,
    defaultProps = _ref.defaultProps;
  var BsComponent = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
    var className = _ref2.className,
      bsPrefix = _ref2.bsPrefix,
      _ref2$as = _ref2.as,
      Tag = _ref2$as === void 0 ? Component || 'div' : _ref2$as,
      props = _objectWithoutProperties(_ref2, ["className", "bsPrefix", "as"]);
    var componentProps = _objectSpread({}, defaultProps, props);
    var resolvedPrefix = useBootstrapPrefix(bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Tag, _objectSpread({
      ref: ref,
      className: classNames(className, resolvedPrefix)
    }, componentProps));
  });
  BsComponent.displayName = displayName;
  return BsComponent;
}